// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-header-container {
    display: flex;
    gap: 16px;
    max-width: 100%;
    background-color: #f1f5f9;
    padding: 0;
}

.news-header-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.news-header {
    background-color: #f8fafc;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    padding: 16px;
    width: 100%;
}

.news-header-content-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 16px;
    flex-wrap: nowrap;
    min-width: 800px;
}

.news-header-section-left {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 16px;
    width: 120px;
}

.news-header-section-center {
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 200px;
    overflow: hidden;
}

.news-header-section-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: auto;
    min-width: 360px;
    max-width: 450px;
    transition: width 0.3s ease;
}

.news-header-title {
    font-size: 24px;
    font-weight: 600;
    color: #1e293b;
    margin: 0;
}

.news-header-stats-container {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 16px;
    background-color: #eef2ff;
    border-radius: 8px;
    border: 1px solid #e0e7ff;
    overflow: hidden;
    max-width: 100%;
}

.news-header-stats-title {
    font-size: 14px;
    color: #4f46e5;
    font-weight: 500;
    flex-shrink: 1;
    overflow: hidden;
    text-overflow: ellipsis;
}

.news-header-stats-content {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #4f46e5;
    flex-shrink: 0;
    overflow: hidden;
}

.news-header-stats-item {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 14px;
    font-weight: 500;
    color: #4f46e5;
}

.news-header-stats-active {
    color: #16a34a;
    font-weight: 600;
}

.news-header-stats-inactive {
    color: #dc2626;
    font-weight: 600;
}

.news-header-stats-divider {
    color: #94a3b8;
    padding: 0 8px;
}

.news-header-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    justify-content: space-between;
}

.news-header-primary-button {
    background-color: #2a5298;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 10px 12px;
    cursor: pointer;
    transition: background-color 0.3s;
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    white-space: nowrap;
    flex: 0 0 auto;
    width: 170px;
    text-align: center;
    min-width: 170px;
}

.news-header-primary-button:hover {
    background-color: #1e3c72;
}

/* Table styles */
.news-table-container {
    overflow-x: auto;
    margin-top: 16px;
    width: 100%;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background-color: white;
}

.news-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

/* Main section styles */
.news-main-section {
    background-color: white;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1;
}

/* Empty state styles */
.news-empty-state {
    text-align: center;
    padding: 40px;
    color: #6c757d;
}

/* Error state styles */
.news-error-state {
    color: red;
    text-align: center;
    padding: 20px;
}

/* Loading state styles */
.news-loading-state {
    text-align: center;
    padding: 20px;
}

/* Container styles */
.news-container {
    display: flex;
    gap: 16px;
    max-width: 100%;
    background-color: #f1f5f9;
    padding: 0;
}

.news-content {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* Стили для компонента выбора даты */
.date-range-picker {
    flex: 0 0 auto;
    position: relative;
    transition: width 0.3s ease;
    width: 170px;
    display: flex;
    justify-content: center;
}

.date-range-picker.expanded {
    width: auto !important;
    min-width: 220px !important;
    justify-content: flex-start;
}

.date-range-picker button {
    width: 100% !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 8px;
    transition: all 0.3s ease;
    font-size: 14px;
    display: flex;
    align-items: center;
}

.date-range-picker button.date-range-expanded {
    width: auto !important;
    min-width: 220px !important;
    max-width: 280px !important;
    padding-right: 12px;
    justify-content: flex-start;
}

.date-range-picker button span {
    transition: all 0.3s ease;
    margin-left: 6px;
}

.date-range-picker-container {
    display: flex;
    justify-content: flex-end;
    flex: 0 0 auto;
    width: auto;
    min-width: 170px;
    transition: width 0.3s ease;
}

.date-range-picker-container.expanded {
    width: auto;
    min-width: 220px;
}

/* Стили для выпадающего календаря */
.date-range-picker .absolute {
    z-index: 50; /* Выше других элементов */
    right: 0;
    width: 600px;
    max-width: 90vw; /* Не больше 90% ширины окна */
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

/* Исправляем стили ячеек календаря */
.date-range-picker .grid-cols-7 button {
    width: 100%;
    justify-content: center;
    text-align: center;
}

/* Исправляем стили для дат следующего месяца */
.date-range-picker .text-gray-400 {
    opacity: 0.6;
}

/* Исправляем стили для раздела быстрого выбора */
.date-range-picker .w-48 {
    width: 12rem;
}

.date-range-picker .w-48 .space-y-1 {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.date-range-picker .w-48 button {
    width: 100%;
    text-align: left;
    justify-content: flex-start;
    padding: 6px 8px;
}

@media (max-width: 640px) {
    .date-range-picker .absolute {
        width: 90vw;
        right: -45vw; /* Центрирование на маленьких экранах */
    }
    
    .date-range-picker .absolute .flex {
        flex-direction: column; /* Колонка вместо строки на маленьких экранах */
    }
    
    .date-range-picker .absolute .w-48 {
        width: 100%;
        border-left: none;
        border-top: 1px solid #e2e8f0;
    }
    
    .date-range-picker .w-48 .space-y-1 {
        display: flex;
        flex-direction: column;
        gap: 4px;
    }
}

/* Медиа-запросы для адаптивности */
@media (max-width: 1200px) {
    .news-header-stats-container {
        flex-direction: column;
        align-items: flex-start;
    }
    
    .news-header-stats-content {
        flex-wrap: wrap;
    }
}

@media (max-width: 1024px) {
    .news-header-content-inner {
        min-width: 700px;
    }
    
    .news-header-section-right {
        width: 360px;
    }
    
    .news-header-section-left {
        width: 100px;
    }
}

@media (max-width: 900px) {
    .news-header-container {
        overflow-x: auto;
    }
    
    .news-header-section-right {
        min-width: 360px;
    }
    
    .date-range-picker button.date-range-expanded {
        max-width: 250px !important;
    }
}

@media (max-width: 768px) {
    .news-header-primary-button {
        width: 120px;
        font-size: 14px;
        padding: 8px 12px;
    }
    
    .date-range-picker-container,
    .date-range-picker {
        width: 120px;
    }
    
    .date-range-picker button {
        padding: 8px 10px;
    }
    
    .news-header-section-right {
        width: 260px;
    }
}

/* Стили для блока языков в сайдбаре */
.language-stats-container {
    background-color: #f9fafb;
    border-radius: 8px;
    padding: 12px;
    margin-bottom: 5px;
    transition: all 0.3s ease;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.language-stats-container:hover {
    background-color: #f3f4f6;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.language-stats-container .text-green-600 {
    color: #16a34a;
    font-weight: 600;
    font-size: 10px;
}

.language-stats-container .text-red-600 {
    color: #dc2626;
    font-weight: 600;
    font-size: 10px;
}

.language-stats-container .bg-green-500 {
    background-color: #22c55e;
    transition: all 0.3s ease;
    min-width: 24px;
}

.language-stats-container .bg-red-500 {
    background-color: #ef4444;
    transition: all 0.3s ease;
    min-width: 24px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/NewsList.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,yCAAyC;IACzC,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,iBAAiB;AACjB;IACI,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,UAAU;AACd;;AAEA,uBAAuB;AACvB;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,UAAU;AACd;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qCAAqC;AACrC;IACI,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,WAAW,EAAE,0BAA0B;IACvC,QAAQ;IACR,YAAY;IACZ,eAAe,EAAE,8BAA8B;IAC/C,qFAAqF;AACzF;;AAEA,qCAAqC;AACrC;IACI,WAAW;IACX,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA,+CAA+C;AAC/C;IACI,YAAY;AAChB;;AAEA,iDAAiD;AACjD;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI;QACI,WAAW;QACX,YAAY,EAAE,uCAAuC;IACzD;;IAEA;QACI,sBAAsB,EAAE,+CAA+C;IAC3E;;IAEA;QACI,WAAW;QACX,iBAAiB;QACjB,6BAA6B;IACjC;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,QAAQ;IACZ;AACJ;;AAEA,mCAAmC;AACnC;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;QACf,iBAAiB;IACrB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA,sCAAsC;AACtC;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;AACnB","sourcesContent":[".news-header-container {\n    display: flex;\n    gap: 16px;\n    max-width: 100%;\n    background-color: #f1f5f9;\n    padding: 0;\n}\n\n.news-header-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.news-header {\n    background-color: #f8fafc;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    padding: 16px;\n    width: 100%;\n}\n\n.news-header-content-inner {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    gap: 16px;\n    flex-wrap: nowrap;\n    min-width: 800px;\n}\n\n.news-header-section-left {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    width: 120px;\n}\n\n.news-header-section-center {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 200px;\n    overflow: hidden;\n}\n\n.news-header-section-right {\n    flex: 0 0 auto;\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    width: auto;\n    min-width: 360px;\n    max-width: 450px;\n    transition: width 0.3s ease;\n}\n\n.news-header-title {\n    font-size: 24px;\n    font-weight: 600;\n    color: #1e293b;\n    margin: 0;\n}\n\n.news-header-stats-container {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 16px;\n    background-color: #eef2ff;\n    border-radius: 8px;\n    border: 1px solid #e0e7ff;\n    overflow: hidden;\n    max-width: 100%;\n}\n\n.news-header-stats-title {\n    font-size: 14px;\n    color: #4f46e5;\n    font-weight: 500;\n    flex-shrink: 1;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.news-header-stats-content {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: #4f46e5;\n    flex-shrink: 0;\n    overflow: hidden;\n}\n\n.news-header-stats-item {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    font-size: 14px;\n    font-weight: 500;\n    color: #4f46e5;\n}\n\n.news-header-stats-active {\n    color: #16a34a;\n    font-weight: 600;\n}\n\n.news-header-stats-inactive {\n    color: #dc2626;\n    font-weight: 600;\n}\n\n.news-header-stats-divider {\n    color: #94a3b8;\n    padding: 0 8px;\n}\n\n.news-header-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.news-header-primary-button {\n    background-color: #2a5298;\n    color: white;\n    border: none;\n    border-radius: 4px;\n    padding: 10px 12px;\n    cursor: pointer;\n    transition: background-color 0.3s;\n    font-size: 14px;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    white-space: nowrap;\n    flex: 0 0 auto;\n    width: 170px;\n    text-align: center;\n    min-width: 170px;\n}\n\n.news-header-primary-button:hover {\n    background-color: #1e3c72;\n}\n\n/* Table styles */\n.news-table-container {\n    overflow-x: auto;\n    margin-top: 16px;\n    width: 100%;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    background-color: white;\n}\n\n.news-table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: fixed;\n}\n\n/* Main section styles */\n.news-main-section {\n    background-color: white;\n    padding: 16px;\n    border-radius: 8px;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    position: relative;\n    z-index: 1;\n}\n\n/* Empty state styles */\n.news-empty-state {\n    text-align: center;\n    padding: 40px;\n    color: #6c757d;\n}\n\n/* Error state styles */\n.news-error-state {\n    color: red;\n    text-align: center;\n    padding: 20px;\n}\n\n/* Loading state styles */\n.news-loading-state {\n    text-align: center;\n    padding: 20px;\n}\n\n/* Container styles */\n.news-container {\n    display: flex;\n    gap: 16px;\n    max-width: 100%;\n    background-color: #f1f5f9;\n    padding: 0;\n}\n\n.news-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* Стили для компонента выбора даты */\n.date-range-picker {\n    flex: 0 0 auto;\n    position: relative;\n    transition: width 0.3s ease;\n    width: 170px;\n    display: flex;\n    justify-content: center;\n}\n\n.date-range-picker.expanded {\n    width: auto !important;\n    min-width: 220px !important;\n    justify-content: flex-start;\n}\n\n.date-range-picker button {\n    width: 100% !important;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    padding: 8px;\n    transition: all 0.3s ease;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n}\n\n.date-range-picker button.date-range-expanded {\n    width: auto !important;\n    min-width: 220px !important;\n    max-width: 280px !important;\n    padding-right: 12px;\n    justify-content: flex-start;\n}\n\n.date-range-picker button span {\n    transition: all 0.3s ease;\n    margin-left: 6px;\n}\n\n.date-range-picker-container {\n    display: flex;\n    justify-content: flex-end;\n    flex: 0 0 auto;\n    width: auto;\n    min-width: 170px;\n    transition: width 0.3s ease;\n}\n\n.date-range-picker-container.expanded {\n    width: auto;\n    min-width: 220px;\n}\n\n/* Стили для выпадающего календаря */\n.date-range-picker .absolute {\n    z-index: 50; /* Выше других элементов */\n    right: 0;\n    width: 600px;\n    max-width: 90vw; /* Не больше 90% ширины окна */\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n/* Исправляем стили ячеек календаря */\n.date-range-picker .grid-cols-7 button {\n    width: 100%;\n    justify-content: center;\n    text-align: center;\n}\n\n/* Исправляем стили для дат следующего месяца */\n.date-range-picker .text-gray-400 {\n    opacity: 0.6;\n}\n\n/* Исправляем стили для раздела быстрого выбора */\n.date-range-picker .w-48 {\n    width: 12rem;\n}\n\n.date-range-picker .w-48 .space-y-1 {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.date-range-picker .w-48 button {\n    width: 100%;\n    text-align: left;\n    justify-content: flex-start;\n    padding: 6px 8px;\n}\n\n@media (max-width: 640px) {\n    .date-range-picker .absolute {\n        width: 90vw;\n        right: -45vw; /* Центрирование на маленьких экранах */\n    }\n    \n    .date-range-picker .absolute .flex {\n        flex-direction: column; /* Колонка вместо строки на маленьких экранах */\n    }\n    \n    .date-range-picker .absolute .w-48 {\n        width: 100%;\n        border-left: none;\n        border-top: 1px solid #e2e8f0;\n    }\n    \n    .date-range-picker .w-48 .space-y-1 {\n        display: flex;\n        flex-direction: column;\n        gap: 4px;\n    }\n}\n\n/* Медиа-запросы для адаптивности */\n@media (max-width: 1200px) {\n    .news-header-stats-container {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n    \n    .news-header-stats-content {\n        flex-wrap: wrap;\n    }\n}\n\n@media (max-width: 1024px) {\n    .news-header-content-inner {\n        min-width: 700px;\n    }\n    \n    .news-header-section-right {\n        width: 360px;\n    }\n    \n    .news-header-section-left {\n        width: 100px;\n    }\n}\n\n@media (max-width: 900px) {\n    .news-header-container {\n        overflow-x: auto;\n    }\n    \n    .news-header-section-right {\n        min-width: 360px;\n    }\n    \n    .date-range-picker button.date-range-expanded {\n        max-width: 250px !important;\n    }\n}\n\n@media (max-width: 768px) {\n    .news-header-primary-button {\n        width: 120px;\n        font-size: 14px;\n        padding: 8px 12px;\n    }\n    \n    .date-range-picker-container,\n    .date-range-picker {\n        width: 120px;\n    }\n    \n    .date-range-picker button {\n        padding: 8px 10px;\n    }\n    \n    .news-header-section-right {\n        width: 260px;\n    }\n}\n\n/* Стили для блока языков в сайдбаре */\n.language-stats-container {\n    background-color: #f9fafb;\n    border-radius: 8px;\n    padding: 12px;\n    margin-bottom: 5px;\n    transition: all 0.3s ease;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.language-stats-container:hover {\n    background-color: #f3f4f6;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.language-stats-container .text-green-600 {\n    color: #16a34a;\n    font-weight: 600;\n    font-size: 10px;\n}\n\n.language-stats-container .text-red-600 {\n    color: #dc2626;\n    font-weight: 600;\n    font-size: 10px;\n}\n\n.language-stats-container .bg-green-500 {\n    background-color: #22c55e;\n    transition: all 0.3s ease;\n    min-width: 24px;\n}\n\n.language-stats-container .bg-red-500 {\n    background-color: #ef4444;\n    transition: all 0.3s ease;\n    min-width: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
